import { ICustomerWalletModalCorrection, ICustomerWalletModalTopUp, ICustomerWalletModalValidation } from '../types';
import { defaultValidation, VALIDITY_PERIOD } from 'src/constants/main';

export enum CUSTOMER_WALLET_MODAL_MODE {
  TOP_UP,
  CORRECTION,
}

export const defaultCustomerWalletModalCorrection: ICustomerWalletModalCorrection = {
  amount: undefined,
  reason: undefined,
};

export const defaultCustomerWalletModalTopUp: ICustomerWalletModalTopUp = {
  ...defaultCustomerWalletModalCorrection,
  periodState: VALIDITY_PERIOD.DAYS,
  periodValue: 0,
};

export const defaultCustomerWalletModalValidation: ICustomerWalletModalValidation = {
  isValid: true,
  amount: defaultValidation,
  reason: defaultValidation,
  period: defaultValidation,
};
